import React from "react";
import { Handle, Position } from "reactflow";
import { useTranslation } from "../i18n/useTranslation";

function NumberNode({ data, selected}) {
  const t = useTranslation();

  return (
    <div
      className={`w-[200px] rounded-lg bg-white shadow-lg overflow-hidden
        transition-all duration-200 ease-in-out
       hover:bg-gray-200   ${
        selected ? "border-solid border-2 border-indigo-500/100" : ""
      }`}
    >
      <div className="flex flex-col">
        <div className="bg-gradient-to-r from-gray-600 to-gray-500 px-4 py-2">
          <div className="text-white text-sm font-medium">
            {t('voiceAgentTitle')}
          </div>
        </div>
        <div className="p-4 space-y-2">
          <div className="text-sm text-gray-700">
            <span className="font-medium">{t('voiceAgentKey')}: </span>
            {data.voice_agent_name || t('defaultAgentName')}
          </div>
          <div className="text-xs text-gray-500">
            <span className="font-medium">{t('sipEndpoint')}: </span>
            {data.phone_number ?? t('phoneNumberPlaceholder')}
          </div>
        </div>
      </div>

      <Handle
        id="a"
        type="source"
        position={Position.Bottom}
        className="w-3 h-3 rounded-full bg-gray-500 border-2 border-white -bottom-1.5"
      />
    </div>
  );
}

export default NumberNode;
